// src/components/DropdownMenu/DropdownMenu.js
import { useEffect, useRef } from "react";
import "./DropdownMenu.css";

export default function DropdownMenu({
  open,
  onClose,
  ariaLabel = "Menu",
  align = "right",
  variant = "dropdown",
  className = "",
  children,
  ...rest // ✅ allow style, id, data-*, etc.
}) {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    function onKeyDown(e) {
      if (e.key === "Escape") onClose?.();
    }

    function onMouseDown(e) {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(e.target)) onClose?.();
    }

    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("click", onMouseDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("click", onMouseDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      ref={menuRef}
      className={`glass ui-menu ui-menu--${align} ui-menu--${variant} ${className}`.trim()}
      role="menu"
      aria-label={ariaLabel}
      {...rest}   // ✅ applies style
    >
      {children}
    </div>
  );
}